module.exports = __webpack_public_path__ + "static/media/product-sustainability.ce8e04cf.svg";